/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SweetpassTierQueryVariables = Types.Exact<{ [key: string]: never }>;

export type SweetpassTierQuery = {
  readonly __typename?: 'Query';
  readonly loyaltyProfile: {
    readonly __typename?: 'LoyaltyProfile';
    readonly customerId: string;
    readonly joinDate: any;
    readonly loyaltyId: string | null;
    readonly tier: {
      readonly __typename?: 'Tier';
      readonly id: string;
      readonly name: Types.TierName;
      readonly nextTier: {
        readonly __typename?: 'Tier';
        readonly id: string;
        readonly name: Types.TierName;
      } | null;
    } | null;
    readonly tierStatus: {
      readonly __typename?: 'TierStatus';
      readonly id: string;
      readonly name: Types.TierStatusName;
    } | null;
    readonly trialEligible: ReadonlyArray<{
      readonly __typename?: 'TrialEligibility';
      readonly duration: number;
      readonly durationUnit: Types.DurationUnit;
    }> | null;
  } | null;
};

export const sweetpassTierQueryMock: ExecutionResult<SweetpassTierQuery> = {
  data: {
    loyaltyProfile: {
      customerId: 'e509e6ea-9fee-442a-9962-587ce7190430',
      joinDate: 'DateTime',
      tier: {
        id: '8da7a716-3ba7-4eda-96e8-a185e3da00a9',
        name: 'OPTED_OUT',
        nextTier: {
          id: 'a4753431-9d08-4060-b59a-a250f9c4016b',
          name: 'OPTED_OUT',
        },
      },
      tierStatus: {
        id: '1bd634cb-273b-47f9-b18d-030f1b1f2c49',
        name: 'ACTIVE',
      },
      trialEligible: [
        { duration: -31, durationUnit: 'DAY' },
        { duration: 97, durationUnit: 'DAY' },
        { duration: 74, durationUnit: 'DAY' },
      ],
      loyaltyId: 'Hello World',
    },
  },
};

export const SweetpassTierDocument = gql`
  query SweetpassTier {
    loyaltyProfile {
      customerId
      joinDate
      tier {
        id
        name
        nextTier {
          id
          name
        }
      }
      tierStatus {
        id
        name
      }
      trialEligible {
        duration
        durationUnit
      }
      loyaltyId
    }
  }
`;

export function useSweetpassTierQuery(
  options?: Omit<Urql.UseQueryArgs<SweetpassTierQueryVariables>, 'query'>,
) {
  return Urql.useQuery<SweetpassTierQuery, SweetpassTierQueryVariables>({
    query: SweetpassTierDocument,
    ...options,
  });
}
